function tuto(ctx) {

	ctx.allowInteraction = false;
  
	let firstNode = ctx.timeline.allSongsValues.find(song => {
		return song.n_children > 0;
	});

	const tour = ctx.$shepherd({
		useModalOverlay: true,
		exitOnEsc: true,
		defaultStepOptions: {
			scrollTo: {behavior: "smooth", block: "center", inline: "center"},
			modalOverlayOpeningPadding: 4,
			cancelIcon: {
				enabled: true
			}
		}
	});

	tour.on("complete", () =>  {
		ctx.allowInteraction = true;
	});

	tour.on("cancel", () =>  {
		ctx.allowInteraction = true;
	});
  
	const buttons = [
		{
			text: "Back",
			action: tour.back,
			classes: "button is-light"
		},
		{
			text: "Next",
			action: tour.next,
			classes: "button is-primary"
		}
	];
  
	const lists = ctx.$refs.lists.sortedData;

	tour.addStep({
		text: "Welcome to Muzsearch: an interactive tool to explore relationships of inspiration and collaboration between artists.",
		buttons: [{
			text: "Next",
			action: tour.next,
			classes: "button is-primary"
		}],
	});
  
	tour.addStep({
		text: `On this timeline are the songs for which the artist ${ctx.artist.name} is involved.`,
		buttons: buttons,
		attachTo: {
			element: "#timeline-1",
			on: "top"
		}
	});
  
	tour.addStep({
		text: `On this timeline are represented the <b>songs at the origin of an adaptation</b> in which the artist ${ctx.artist.name} is involved.`,
		buttons: buttons,
		attachTo: {
			element: "#timeline-0",
			on: "top"
		}
	});
  
	tour.addStep({
		text: `On this timeline are the <b>adaptations from songs</b> in which the artist ${ctx.artist.name} is involved.`,
		buttons: buttons,
		attachTo: {
			element: "#timeline-2",
			on: "top"
		}
	});
  
	tour.addStep({
		text: `Here it is possible to see the artists who <b> most often inspired </b> ${ctx.artist.name}.`,
		buttons: buttons,
		attachTo: {
			element: "#list-source",
			on: "top"
		}
	});
  
	tour.addStep({
		text: `In first place, we find <b>${lists.source[0].artist.name}</b>, with ${lists.source[0].source.total} implications.`,
		buttons: buttons,
		attachTo: {
			element: "#list-source .artist-list-item:first-child",
			on: "top"
		}
	});
  
	tour.addStep({
		text: `Here, it is possible to see the artists who <b>have collaborated most often</b> with ${ctx.artist.name}.`,
		buttons: buttons,
		attachTo: {
			element: "#list-own",
			on: "top"
		}
	});
  
	tour.addStep({
		text: `In first place, we find <b>${lists.own[1].artist.name}</b>, with ${lists.own[1].own.total} implications.`,
		buttons: buttons,
		attachTo: {
			element: "#list-own .artist-list-item:nth-child(2)",
			on: "top"
		}
	});
  
	tour.addStep({
		text: `Here, it's possible to see the artists who <b>were most often inspired</b> by ${ctx.artist.name}.`,
		buttons: buttons,
		attachTo: {
			element: "#list-target",
			on: "top"
		}
	});
  
	tour.addStep({
		text: `In first place, we find <b>${lists.target[0].artist.name}</b>, with ${lists.target[0].target.total} implications.`,
		buttons: buttons,
		attachTo: {
			element: "#list-target .artist-list-item:first-child",
			on: "top"
		}
	});
  
	tour.addStep({
		text: "You can search for a specific song using the <b>search bar</b>.",
		buttons: buttons,
		attachTo: {
			element: "#song-search",
			on: "bottom"
		}
	});
  
	tour.addStep({
		text: "When you <b>click on a song</b>, you can see the adaptation tree in which this song belongs.",
		buttons: buttons,
		attachTo: {
			element: `#node-${firstNode.id}`,
			on: "top"
		},
		beforeShowPromise: () => {
			ctx.selectedSong = firstNode.id;
		}
	});
  
	tour.addStep({
		text: `We notice here that the song "${firstNode.label}" was adapted ${firstNode.n_children} time(s).`,
		buttons: [
			{
				text: "Back",
				action: tour.back,
				classes: "button is-light"
			},
			{
				text: "Finish",
				action: tour.next,
				classes: "button is-primary"
			}
		],
		attachTo: {
			element: ".timeline-tree-container",
			on: "top"
		}
	});

	tour.start();
}

export default tuto;
